// HTTP headers used to trace requests across the FE server, the client and the
// BE/FE apis. See common/composables/useAwRequestTracing.ts for how they are set.

/**
 * Identifies the browser tab: generated once per FE server request, returned to
 * the client in the response and reused for every XHR made from that tab.
 */
export const HEADER_X_AW_TAB_ID = 'x-aw-tab-id';

/**
 * Unique per outgoing BE/FE api XHR.
 */
export const HEADER_X_AW_REQUEST_ID = 'x-aw-request-id';
